import { Document } from '@contentful/rich-text-types'

// Type guard for a valid contentful document
export function isValidDocument(doc: unknown): doc is Document {
  return !!doc && typeof doc === 'object' && 'content' in doc
}
